import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LoaderService {
    // -----------------------------------------------------
    // ------------------ ACTIVE LOADERS -------------------
    // Segir til um hversu margir acitve loaders eru í notkun.
    private bhActiveLoaders = new BehaviorSubject(0);
    activeLoaders = this.bhActiveLoaders.asObservable();

    hasActiveDotsInterval = false;
    changeActiveLoaders(adder: number) {
        let dotsInterval;
        let currentActiveLoaders: number;
        this.activeLoaders.subscribe((loaders) => (currentActiveLoaders = loaders));

        // Makes sure the loader will never go below 0
        let _adder = currentActiveLoaders + adder;
        if (_adder >= 0) {
            this.bhActiveLoaders.next(_adder);
        } else {
            this.bhActiveLoaders.next(0);
        }

        if (currentActiveLoaders >= 1) {
            this.changeLoader(true);
            try {
                if (!this.hasActiveDotsInterval) {
                    dotsInterval = setInterval(() => {
                        var wait = document.getElementById('wait');
                        if (wait) {
                            if (wait.innerHTML.length > 2) {
                                wait.innerHTML = '';
                            } else {
                                wait.innerHTML += '.';
                            }
                        }
                    }, 500);
                }
                this.hasActiveDotsInterval = true;
            } catch (e) {}
        } else if (currentActiveLoaders <= 0) {
            this.bhActiveLoaders.next(0);
            this.changeLoader(false);
            this.changeLoaderMessage('');
            clearInterval(dotsInterval);
        }
    }

    // -----------------------------------------------------
    // ------------------ LOADER MESSAGE -------------------
    private bhLoaderMessage = new BehaviorSubject('');
    private bhLoaderMessageChanged = new BehaviorSubject(false);
    /**
     * Heldur utan um loader message
     */
    loaderMessage = this.bhLoaderMessage.asObservable();

    /**
     * Breyta loader message.
     * @param message loader message sem á að birta.
     */
    changeLoaderMessage(message: string) {
        if (message != '') {
            this.bhLoaderMessageChanged.next(true);
            this.bhLoaderMessage.next(message);
        }
    }

    // -----------------------------------------------------
    // ------------------ MAIN-LOADER ----------------------
    private bhLoader = new BehaviorSubject(false);
    private bhLoaderBlocked = new BehaviorSubject(false);
    private bhShowImageLoader = new BehaviorSubject(false);
    /**
     * Segir til um hvort sýna eigi loader.
     */
    loader = this.bhLoader.asObservable();
    loaderBlocked = this.bhLoaderBlocked.asObservable();
    showImageLoader = this.bhShowImageLoader.asObservable();

    /**
     * Breyta því hvort loader sé sjáanlegur eða ekki.
     * @param show sýna loader
     */
    changeLoader(show: boolean) {
        let isBlocked: boolean;
        this.loaderBlocked.subscribe((bl) => (isBlocked = bl));
        if (!isBlocked) {
            this.bhLoader.next(show);
        } else {
            this.bhActiveLoaders.next(0);
            this.bhLoader.next(false);
        }
    }

    /**
     * Alveg sama hvað active loaders er þá mun loader ekki birtast þar til
     * blocked er sett sem false aftur.
     * @param blocked
     */
    changeLoaderBlocked(blocked: boolean) {
        if (blocked) {
            this.bhActiveLoaders.next(0);
            this.bhLoader.next(false);
        }
        this.bhLoaderBlocked.next(blocked);
    }

    /**
     * Segir til um hvort sýna eigi mynd með loader
     * @param show
     */
    changeShowImageLoader(show: boolean) {
        this.bhShowImageLoader.next(show);
    }

    constructor() {}
}
